
import { httpMemberPackageInfo } from '~/api/common.js'
export default {
  name: 'SeniorUser',
  data() {
    return {
      isBase: false,
      bingo_src: require('~/assets/image/price/bingomobile.png'),
      base: {
        title: '基础版',
        info: [
          '不限制答卷收集数量',
          '30万+模板资源',
          '40+种项目题型',
          '项目支持添加在线音视频',
          '项目支持设置题目跳转和显示逻辑',
          '支持答题后抽取微信红包',
          '支持通过短信或邮件分享项目',
          '提供有偿的样本收集服务',
          '项目支持小规模团队协作',
          '单个文件最大30MB',
          '每月1GB文件上传空间',
          '支持分享项目数据下载',
          '考试项目支持练习模式',
          '考试项目支持防作弊',
          '考试项目支持交卷时间设置',
          '考试项目支持排行榜',
          '考试项目支持按得分设置结束语',
        ],
      },
      senior: {
        title: '高级版',
        info: [
          '基础版所有功能',
          '项目支持设置自定义抽奖',
          '项目支持设置微信签到',
          '项目支持配额',
          '项目支持地图导航题',
          '项目支持地理位置题精准定位',
          '项目支持隐藏答题页问卷网标志',
          '项目支持满意度维度设置',
          '项目支持添加本地视频：最大50MB/个',
          '项目支持添加本地音频：最大10MB/个',
          '赠送答题免广告额度：10万次',
          '项目支持设置投票墙',
          '单个文件最大50MB',
          '每月10GB文件上传空间',
          '支持增购文件上传空间',
          '支持项目数据公开分享',
        ],
      },
      enterprise: {
        title: '企业版',
        info: [
          '高级版所有功能',
          '支持360评估场景',
          '支持问卷网开放平台',
          '支持企业协作',
          '支持自定义答卷来源',
          '支持关注自有微信号才能答卷与领取红包',
          '支持自定义http域名',
          '项目支持添加本地视频：最大100MB/个',
          '项目支持添加本地音频：最大20MB/个',
          '赠送企业子账号：10个',
          '赠送答题免广告额度：30万次',
          '项目支持设置答题视频页眉',
          '项目支持设置答题加载动效',
          '考试项目支持设置考试证书',
          '项目支持设置打开答题页跳转',
          '项目支持设置提交答卷后跳转',
          '支持自定义项目内短信签名',
          '单个文件最大100MB',
          '每月20GB文件上传空间',
          '支持增购文件上传空间',
        ],
      },
      ultimate: {
        title: '企业旗舰版',
        info: [
          '高级版所有功能',
          '支持360评估场景',
          '支持问卷网开放平台',
          '支持企业协作',
          '支持自定义答卷来源',
          '支持自定义发件邮箱地址',
          '支持关注自有微信号才能答卷与领取红包',
          '项目支持自定义http与https域名',
          '项目支持添加本地视频：最大200MB/个',
          '项目支持添加本地音频：最大50MB/个',
          '赠送企业子账号：30个',
          '赠送答题免广告额度：150万次',
          '单个文件最大200MB',
          '每月50GB文件上传空间',
          '支持增购文件上传空间',
        ],
      },
      qaList: [
        [
          'Q1. 问卷网可以使用哪些场景和题型？',
          '问卷网现提供问卷调查、满意度调查、投票评选、报名登记表、考试测评等场景。题型涵盖单选/多选题、图片选择/上传题、投票题、填空题、打分题、人口统计信息题等40多种题型。',
        ],
        [
          'Q2. 如何确保数据存储安全性？',
          '问卷网始终将数据安全放在第一位。我们对系统部署了完善的加密功能，使用Https加密协议，保证数据在传输过程中绝对安全，同时在服务器端配置有完善的数据备份方案，让您安心使用无后顾之忧。',
        ],
        [
          'Q3. 如何支付并购买套餐？',
          '问卷网PC端提供了微信支付和支付宝支付两种在线支付方式。同时我们还提供了线下支付，在问卷网PC端进入“我的账户-我的钱包”，选择“银行转账”后根据转账提示完成转账。我们将在工作日的24h内为您的账户充值，您可使用账户余额购买套餐。',
        ],
      ],
    }
  },
  fetchOnServer: false,
  async fetch() {
    await this.init()
  },
  head: {
    title: '问卷网_免费版、高级版、定制版的区别',
    link: [{ rel: 'canonical', href: 'https://www.wenjuan.com/senior_user/' }],
    meta: [
      {
        hid: 'keywords',
        name: 'keywords',
        content: '免费版，高级版，定制版，调查问卷，问卷调查，问卷网',
      },
      {
        hid: 'description',
        name: 'description',
        content: '问卷网，免费专业的在线调研、报名表单、考试测评平台。用户可查看问卷网免费版、高级版、定制版的区别。',
      },
    ],
    script: [{ src: '//s1.wenjuan.com/lib/jquery/1.8.3/jquery.min.js' }],
  },
  computed: {
    loggedIn() {
      return this.$store.state.loginStatus.loggedIn == 1
    },
  },

  methods: {
    init() {
      return httpMemberPackageInfo({ is_get_personal_package_info: 1 })
        .then((res) => {
          console.log('res', res)
          if (!res.data.package_status) {
            this.isBase = true
          }
        })
        .catch((err) => {
          console.log('请求httpMemberPackageInfo：error：', err)
        })
    },
    tryApply() {
      this.$href('https://www.wenjuan.com/s/UZBZJvX9GO6/#')
    },
    service() {
      this.$href('https://www.wenjuan.com/m/help/detail/56a5f21da320fc6ab839e110')
    },
  },
}
